import React, { ReactNode } from 'react';
import { useApp } from 'hooks/useApp';
import { SIDEBAR_WIDTH } from 'constants/constants';
import { makeStyles, Theme } from '@material-ui/core';
import Sidebar from 'components/template/sidebar/Sidebar';

interface StyleProps {
  sidebarWidth: number;
  isOpenedMenu: boolean;
}

const styles = makeStyles<Theme, StyleProps>(theme => ({
  sidebarWrapper: {
    position: 'fixed',
    height: '100%',
    zIndex: 1101,
  },
  container: {
    display: 'flex',
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
  content: {
    minHeight: 'calc(100vh - 64px)',
    padding: '20px 30px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      padding: '15px',
    },
    '@media print': {
      padding: 0,
    },
  },
  contentWrapper: props => ({
    width: '100%',
    margin: '64px 0 0',
    transition: 'padding-left 0.4s ease',
    paddingLeft: props.isOpenedMenu ? props.sidebarWidth : 0,
    position: 'relative',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
    },
    [theme.breakpoints.down('xs')]: {
      margin: '57px 0 0',
    },
    '@media print': {
      padding: 0,
      margin: 0,
      overflowY: 'initial',
    },
  }),
}));

interface DefaultLayoutProps {
  children: ReactNode;
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({ children }) => {
  const { isOpenedMenu } = useApp();

  const classes = styles({ sidebarWidth: SIDEBAR_WIDTH, isOpenedMenu });

  return (
    <div className={classes.container}>
      <div className={classes.sidebarWrapper}>
        <Sidebar />
      </div>
      <div className={classes.contentWrapper} id="content-wrapper">
        <div id="app-content" className={classes.content}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
